import React, { useContext, useState } from "react";
import { notificationPeriodicType } from "../../constants";
import { searchAPI } from "../../services/api/search";
import { SearchContext } from "../../store/search-context";
import styles from "../../styles/SearchSuscriptionModal.module.css";
import footerStyles from "../../styles/ModalFooter.module.css";
import { getDefaultNotificationPerodic } from "../../utils/search";
import { useParams } from "react-router-dom";
import { getCookie } from "../../utils/common";
import { hasSpecialCharacters, replaceHtmlTags } from "../Common/Common";

const SubscriptionModal = () => {
  const searchCtx = useContext(SearchContext);
  const { uuid } = useParams();

  const [status, setStatus] = useState("");
  const [error, setError] = useState("");
  const [titleError, setTitleError] = useState("");

  const onChangeName = (e: React.ChangeEvent<HTMLInputElement>) => {
    searchCtx.updateName(e.target.value);
  };

  const onChangeNotification = (e: React.ChangeEvent<HTMLInputElement>) => {
    searchCtx.updateNotificationPeriodic(e.target.value);
  };

  const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");
    setStatus("");
    setTitleError("");
    if (status === "progress" || !searchCtx.name) return;

    if (hasSpecialCharacters(searchCtx.name)) {
      setTitleError("Special characters are not allowed in the title");
      return;
    }

    setStatus("progress");

    const payload = {
      name: replaceHtmlTags(searchCtx.name),
      filters: searchCtx.filters,
      email_notify: searchCtx.notificationPeriodic,
    };
    const tenantSlug = getCookie("current_tenant");
    //  If possible optimize this
    if (uuid) {
      searchAPI(tenantSlug)
        .put?.(uuid, payload)
        .then((response) => {
          setStatus("success");
          setTimeout(() => {
            cancelHandler();
          }, 3000);
        })
        .catch((err) => {
          setStatus("failed");
          setTimeout(() => {
            setStatus("");
          }, 3000);
          setError("Something went wrong. Please try again later.");
          console.log(err);
        });
    } else {
      searchAPI(tenantSlug)
        .post?.(payload)
        .then((response) => {
          setStatus("success");
          setTimeout(() => {
            cancelHandler();
          }, 3000);
        })
        .catch((err) => {
          setStatus("failed");
          setTimeout(() => {
            setStatus("");
          }, 3000);
          setError("Something went wrong. Please try again later.");
          console.log(err);
        });
    }
  };

  const cancelHandler = (e?: React.MouseEvent<HTMLButtonElement>) => {
    if (e?.currentTarget.dataset.bsDismiss === "modal") {
      const defaultNotification = getDefaultNotificationPerodic();
      searchCtx.updateName("");
      searchCtx.updateNotificationPeriodic(defaultNotification);
    } else {
      const cancelModal = document
        .getElementById("subscriptionModal")
        ?.querySelectorAll(
          ".dismiss-subscriptionModal"
        )[0] as HTMLButtonElement;
      cancelModal.click();
      setStatus("");
      searchCtx.setDefault();
    }
  };

  const notificationPeriodicListUI = notificationPeriodicType.map(
    ({ type, title }, i) => {
      return (
        <li className="form-check" key={`${type}-${i}`}>
          <input
            className="form-check-input"
            type="radio"
            name="email-notification"
            id={`${type}-notification`}
            value={type}
            onChange={(e) => onChangeNotification(e)}
            checked={searchCtx.notificationPeriodic === type ? true : false}
          />
          <label
            className={`form-check-label ${styles.filterTitle}`}
            htmlFor={`${type}-notification`}
            role="button"
          >
            {title}
          </label>
        </li>
      );
    }
  );

  return (
    <div
      className={`modal fade ${styles.subscriptionModal}`}
      id="subscriptionModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="subscriptionModalLabel">
              Subscribe to This Search
            </h5>
            <div>
              <small>
                {Object.keys(searchCtx.filters).reduce(
                  (prev, currentVal) =>
                    prev + (typeof(searchCtx.filters[currentVal]) == 'string' ?  searchCtx.filters[currentVal].split().length : searchCtx.filters[currentVal].length),
                  0
                )}{" "}
                Filters Applied | {searchCtx.conversationsCount} Conversations
              </small>
            </div>
          </div>
          <form onSubmit={submitHandler}>
            <div className="modal-body">
              <div className="mb-4">
                <label
                  htmlFor="subscription-name"
                  className={`${styles.formLabel} mb-2`}
                >
                  Name:
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="subscription-name"
                  name="subscription-name"
                  value={searchCtx.name}
                  onChange={onChangeName}
                />
                {titleError ? (
                  <span className={styles.error}>{titleError}</span>
                ) : null}
              </div>
              {/* <div className="mb-3">
                                    <label className={`${styles.formLabel} mb-2`}>Email Notifications</label>
                                    <ul className="list-unstyled">
                                        {notificationPeriodicListUI.length && notificationPeriodicListUI}
                                    </ul>
                                </div> */}
            </div>
            <div
              className={`modal-footer d-flex justify-content-between ${footerStyles.modalFooter}`}
            >
              {
                <div
                  className={!status ? footerStyles.actionsBlock : "invisible"}
                >
                  <button
                    type="button"
                    className="btn btn-secondary dismiss-subscriptionModal"
                    data-bs-dismiss="modal"
                    onClick={cancelHandler}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className={`btn btn-primary ${
                      !searchCtx.name && "disabled"
                    }`}
                  >
                    Add to HomePage
                  </button>
                </div>
              }
              {
                <div
                  className={`${footerStyles.actionFailed} ${
                    status === "failed" ? footerStyles.slideIn : "invisible"
                  }`}
                >
                  Oops! Subscription Failed
                </div>
              }
              {
                <div
                  className={`${footerStyles.actionSuccess} ${
                    status === "success" ? footerStyles.slideIn : "invisible"
                  }`}
                >
                  Subscription Successful!
                </div>
              }
              {
                <div
                  className={`${footerStyles.actionProgress} ${
                    status === "progress" ? footerStyles.slideIn : "invisible"
                  }`}
                >
                  Subscribing...
                  <div className={footerStyles.cdLoading}></div>
                </div>
              }
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionModal;
